import React from "react";
import { Textarea } from "theme/components/atoms/Form/Input";
import FormItem from "theme/components/molecules/Form/Item";
import CustomOptionLabelWithPrice from "./CustomOptionLabelWithPrice";
import MaxLengthNote from "./MaxLengthNote";

const CustomOptionTextarea = (props) => {
  const maxLength = props.max_characters || undefined;

  return (
    <FormItem label={<CustomOptionLabelWithPrice option={props} />}>
      <Textarea
        name={props.option_id}
        id={props.option_id}
        value={props.selectedOption}
        required={props.required}
        maxLength={maxLength}
        help={maxLength && <MaxLengthNote maxLength={maxLength} />}
      />
    </FormItem>
  );
};

export default CustomOptionTextarea;
